export const FEED_ITEM_EDIT_DIALOG_ROOT = 'post editor root';
export const FEED_ITEM_EDIT_DIALOG_CANCEL_BUTTON = 'post editor cancel button';
export const FEED_ITEM_EDIT_DIALOG_OK_BUTTON = 'post editor confirm button';
